/* eslint-disable no-use-before-define */
import React from 'react';
import Comments from '../Elements/Comments';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import LogComponent from '../Elements/LogComponent';
import AddressAdmin from '../Contents/Sales/AddressAdmin/AddressAdmin';
import SurveyAdmin from '../Contents/Sales/ClientAdmin/SurveyAdmin/SurveyAdmin';
import dateTimeHelper from '../Helpers/datetimeHelper';
import ContactComponent from '../Contents/Sales/ContactAdmin/ContactComponent';
import LocationsAdmin from '../Contents/Operations/Locations/LocationsAdmin';
import ProjectComponent from '../Contents/Operations/Projects/ProjectComponent';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import OpportunityAdmin from '../Contents/Sales/OpportunityAdmin/OpportunityAdmin';
import FigmaBadge from '../Elements/FigmaBadge';
import FinalizedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/FinalizedAssignmentsList';
import UninvoiceableAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/UninvoiceableAssignmentsList';
import ExcludedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/ExcludedAssignmentsList';
import AllAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/AllAssignmentsList';
import TabbedPage from '../Elements/TabbedPage';
import urlHelper from '../Helpers/urlHelper';
import LongText from '../Elements/LongText';
import ClientAdmin from '../Contents/Sales/ClientAdmin/ClientAdmin';
import userHelper from '../Helpers/userHelper';
import TpClientLinkAdmin from '../Contents/ThirdParty/TpClientLink/TpClientLinkAdmin';
import TpSurveyAdmin from '../Contents/ThirdParty/TpSurvey/TpSurveyAdmin';
import NewProjectAdmin from '../Contents/ThirdParty/Project/NewProjectAdmin';
import FinalizedTpJobsAdmin from '../Contents/Operations/TpJob/FinalizedTpJobsAdmin';
import UninvoiceableTpJobAdmin from '../Contents/Operations/TpJob/UninvoiceableTpJobAdmin';
import ExcludedTpJobsAdmin from '../Contents/Operations/TpJob/ExcludedTpJobsAdmin';
import AllTpJobsAdmin from '../Contents/Operations/TpJob/AllTpJobsAdmin';
import ClientPricingHistoryTab from '../Contents/Sales/ClientAdmin/ClientPricingHistory/ClientPricingHistoryTab';
import ClientPricingHistoryService from '../Services/clientPricingHistoryService';

export default class ClientItem {
  constructor(item) {
    if (item === undefined) {
      this.ClientId = '';
      this.Name = '';
      this.Comments = '';
      this.LeadId = '';
      this.ParentId = '';
      this.ContactId = '';
      this.TypeCode = '';
      this.SalesRepId = '';
      this.AcctMgrId = '';
      this.OfficeId = '';
      this.IndustryCode = '';
      this.MainPhone = '';
      this.OtherPhone = '';
      this.Fax = '';
      this.WebSiteUrl = '';
      this.Email = '';
      this.ReferralSourceCode = '';
      this.AddressId = '';
      this.ShippingMethodCode = '';
      this.BillingScheduleCode = '';
      this.Vatnumber = '';
      this.AllowBulkEmail = '';
      this.AllowEmail = '';
      this.AllowFax = '';
      this.AllowPhone = '';
      this.AllowPostalMail = '';
      this.AllowSendMedia = '';
      this.PrefContactMethodCode = 1;
      this.StatusCode = 1;
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.IsActive = true;
      this.TimeZoneOffset = '';
      this.SassieId = '';
      this.InvoiceInterestRate = 0;
      this.DaysToPayCode = 30;
      this.UseSummaryReport = false;
      this.Level1 = '';
      this.Level2 = '';
      this.Level3 = '';
      this.Level4 = '';
      this.Level5 = '';
      this.GroupLabel = '';
      this.GroupList = '';
      this.CheckInByDate = this.StartDate = dateTimeHelper.lastDayOfTheActualMonth();
      this.IsMspartner = '';
      this.MspartnerCode = '';
      this.MSPartner = '';
      this.Status = '';
      this.Indrustry = '';
      this.OfficeName = '';
      this.Country = '';
      this.State = '';
      this.City = '';
      this.PostalCode = '';
      this.AddressType = '';
      this.AddressName = '';
      this.AddressStreet = '';
      this.PrimaryContact = '';
      this.ReferalSource = '';
      this.TimeZoneOffsetText = '';
      this.ParentName = '';
      this.Lead = '';
      this.Preferred = '';
      this.DaysToPay = '';
      this.ApolloClientName = '';
      this.IsSubClientsView = false;
      this.IsCurrentUserBareManager = false;
      this.CurrentUserBareManagerIsActive = false;
      this.AllowExtendedJobExport = false;
      this.ExtendedExportUntilUtc = null;
      this.ExtendedExportUntilUtcOriginal = null;
      return;
    }
    this.ClientId = item.clientId;
    this.Name = item.name;
    this.Comments = item.comments;
    this.LeadId = item.leadId;
    this.ParentId = item.parentId;
    this.ContactId = item.contactId;
    this.TypeCode = item.typeCode;
    this.SalesRepId = item.salesRepId;
    this.AcctMgrId = item.acctMgrId;
    this.OfficeId = item.officeId;
    this.IndustryCode = item.industryCode;
    this.MainPhone = item.mainPhone;
    this.OtherPhone = item.otherPhone;
    this.Fax = item.fax;
    this.WebSiteUrl = item.webSiteUrl;
    this.Email = item.email;
    this.ReferralSourceCode = item.referralSourceCode;
    this.AddressId = item.addressId;
    this.ShippingMethodCode = item.shippingMethodCode;
    this.BillingScheduleCode = item.billingScheduleCode;
    this.Vatnumber = item.vatnumber;
    this.AllowBulkEmail = item.allowBulkEmail;
    this.AllowEmail = item.allowEmail;
    this.AllowFax = item.allowFax;
    this.AllowPhone = item.allowPhone;
    this.AllowPostalMail = item.allowPostalMail;
    this.AllowSendMedia = item.allowSendMedia;
    this.PrefContactMethodCode = item.prefContactMethodCode;
    this.StatusCode = item.statusCode;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.IsActive = item.isActive;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.SassieId = item.sassieId;
    this.InvoiceInterestRate = item.invoiceInterestRate;
    this.DaysToPayCode = item.daysToPayCode;
    this.UseSummaryReport = item.useSummaryReport;
    this.Level1 = item.level1;
    this.Level2 = item.level2;
    this.Level3 = item.level3;
    this.Level4 = item.level4;
    this.Level5 = item.level5;
    this.GroupLabel = item.groupLabel;
    this.GroupList = item.groupList;
    this.CheckInByDate = item.checkInByDate;
    this.IsMspartner = item.isMspartner;
    this.MspartnerCode = item.mspartnerCode;
    this.Status = item.status;
    this.Indrustry = item.indrustry;
    this.OfficeName = item.officeName;
    this.Country = item.country;
    this.State = item.state;
    this.City = item.city;
    this.PostalCode = item.postalCode;
    this.AddressType = item.addressType;
    this.AddressName = item.addressName;
    this.AddressStreet = item.addressStreet;
    this.MSPartner = item.msPartner;
    this.PrimaryContact = item.primaryContact;
    this.PrimaryAccountMgr = item.primaryAccountMgr;
    this.PrimarySalesReportUser = item.primarySalesReportUser;
    this.ReferalSource = item.referalSource;
    this.TimeZoneOffsetText = item.timeZoneOffsetText;
    this.ParentName = item.parentName;
    this.Lead = item.lead;
    this.Preferred = item.preferred;
    this.DaysToPay = item.daysToPay;
    this.ApolloClientName = item.apolloClientName;
    this.IsSubClientsView = item.isSubClientsView;
    this.IsCurrentUserBareManager = item.isCurrentUserBareManager;
    this.CurrentUserBareManagerIsActive = item.currentUserBareManagerIsActive;
    this.AllowExtendedJobExport = !!item.extendedJobExportUntilUtc;
    this.ExtendedJobExportUntilUtc = item.extendedJobExportUntilUtc;
    this.ExtendedJobExportUntilUtcOriginal = item.extendedJobExportUntilUtc;
  }

  static NameOfTheIdField() {
    return 'ClientId';
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          Client -{' '}
          <LongText
            text={`${item.Name} (${item.ClientId})`}
            maxLength={50}
          />
        </span>
      );
    return 'Client';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CheckInByDate', 'ModifiedOn'];
  static BoolFields = [
    'IsMspartner',
    'AllowFax',
    'AllowEmail',
    'AllowPhone',
    'AllowBulkEmail',
    'AllowPostalMail',
    'AllowSendMedia',
  ];

  static getGeneralEditContent(item) {
    return (
      <div
        className='link'
        onClick={() => ClientItem.editGeneralFunction(item)}
      >
        Edit General
      </div>
    );
  }

  static getAddressContent(item) {
    return (
      <AddressAdmin
        EntityTypeId={7} //Client
        EntityId={item.ClientId}
      />
    );
  }

  static GetLeadCellContent(item) {
    if (!item.LeadId) return '';

    return urlHelper.getIconLinkComponentFigma(
      `${item.Lead} (${item.LeadId})`,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales/search',
      `LeadId=${item.LeadId}`,
      'Open lead on a new tab'
    );
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: "Id", orderById: "ClientId", data: ClientItem.getIdFieldData, type: ClientItem.getIdFieldType, minWidth: 70 },
      { label: "Name", orderById: "Name", data: (item) => (<LongText text={item.Name} maxLength={40} />), type: FieldTypesEnum.PureDataField, },
      { label: "Check-in by Date", orderById: "CheckInByDate", data: "CheckInByDate", type: FieldTypesEnum.PureDataField, minWidth: "110px", },
      { label: "Office Name", orderById: "Office", data: "OfficeName", type: FieldTypesEnum.PureDataField, },
      { label: "Country", orderById: "Country", data: "Country", type: FieldTypesEnum.PureDataField, },
      { label: "State", orderById: "State", data: "State", type: FieldTypesEnum.PureDataField, },
      { label: "Industry", orderById: "IndustryCode", data: "Indrustry", type: FieldTypesEnum.PureDataField, },
      { label: "Active?", orderById: "IsActive", data: ClientItem.getIsActiveCellContent, type: FieldTypesEnum.PureDataField, minWidth: 50, },
      { label: "Status", orderById: "Status", data: "Status", type: FieldTypesEnum.PureDataField, },
      { label: "Modified On", orderById: "ModifiedOn", data: "ModifiedOn", type: FieldTypesEnum.PureDataField, },
      { label: "Actions", orderById: "", data: ClientItem.getActionsCellContent, type: FieldTypesEnum.ActionButton, },
    ];
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "ClientId", label: "Client Id", className: "text-left" },
        { name: "Name", label: "Name", className: "text-left" },
        { name: "Indrustry", label: "Industry", className: "text-left" },
        { name: (item) => ClientItem.GetParentCellContent(item), label: "Parent", className: "text-left" },
        { name: "PrimaryContact", label: "Primary Contact", className: "text-left", },
        { name: ClientItem.GetLeadCellContent, label: "Lead", className: "text-left" },
        { name: "OfficeName", label: "Office ", className: "text-left" },
        { name: "IsMspartner", label: "MS Partner", className: "text-left" },
        { name: "MSPartner", label: "MS Partner", className: "text-left" },
        { name: (item) => JsxHelper.YesNo(item.IsActive), label: "Status", className: "text-left", },

        { name: "-message-", label: "Management", className: "text-left" },

        { name: "PrimarySalesReportUser", label: "Primary Sales Rep", className: "text-left", },
        { name: "ReferalSource", label: "Referral Source", className: "text-left", },
        { name: "PrimaryAccountMgr", label: "Primary Account Mgr", className: "text-left", },
        { name: "Status", label: "Status", className: "text-left" },
        { name: "CheckInByDate", label: "Check-in by Date", className: "text-center", },

        { name: "-message-", label: "Billing", className: "text-left" },

        { name: "Vatnumber", label: "Tax Number", className: "text-left" },
        { name: "DaysToPay", label: "Days To Pay", className: "text-center" },
        { name: "UseSummaryReport", label: "Invoice Form Type", className: "text-left", },
        { name: "InvoiceInterestRate", label: "Late Fee %", className: "text-left", },

        { name: "-message-", label: "Contact Information", className: "text-left", },
        { name: "MainPhone", label: "Main Phone", className: "text-left" },
        { name: (item) => urlHelper.getLinkComponent(item.WebSiteUrl), label: "Website Url", className: "text-left", },
        { name: "TimeZoneOffsetText", label: "Time Zone", className: "text-left", },
        { name: "SassieId", label: "Apollo ID", className: "text-left" },
        { name: "ApolloClientName", label: "Apollo Client Name", className: "text-left", },

        { name: "-message-", label: "Address", className: "text-left" },

        { name: "AddressName", label: "Address Name", className: "text-left" },
        { name: "State", label: "State", className: "text-left" },
        { name: "AddressStreet", label: "Address", className: "text-left" },
        { name: "PostalCode", label: "Postal Code", className: "text-left" },
        { name: "Country", label: "Country", className: "text-left" },
        { name: "City", label: "City", className: "text-left" },
        { name: "AddressType", label: "Address Type", className: "text-left" },

        { name: "-message-", label: "Location Levels", className: "text-left" },

        { name: "Level1", label: "Level 1", className: "text-left" },
        { name: "Level2", label: "Level 2", className: "text-left" },
        { name: "Level3", label: "Level 3", className: "text-left" },
        { name: "Level4", label: "Level 4", className: "text-left" },
        { name: "Level5", label: "Level 5", className: "text-left" },
        { name: "GroupLabel", label: "Group Label", className: "text-left" },
        { name: "-message-", label: "Contact Methods", className: "text-left" },
        { name: "Preferred", label: "Preferred", className: "text-left" },
        { name: "AllowFax", label: "Allow Fax", className: "text-left" },
        { name: "AllowEmail", label: "Allow Email", className: "text-left" },
        { name: "AllowPhone", label: "Allow Phone", className: "text-left" },
        { name: "AllowBulkEmail", label: "Allow Bulk Email", className: "text-left", },
        { name: "AllowPostalMail", label: "Allow Postal Mail", className: "text-left", },
        { name: "AllowSendMedia", label: "Allow Send Media", className: "text-left", },
        { name: "Comments", label: "Comment", width: TabListTableCellWidthEnum.TwoLines, },
      ],
    },
    {
      tabName: "Addresses", tabLabel: "Addresses", icon: "fa-solid fa-map-location-dot fa-2x",
      data: [
        { name: ClientItem.getAddressContent, label: "Addresses", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Contact", tabLabel: "Contact", icon: "fa-regular fa-address-book fa-2x",
      data: [
        { name: ClientItem.getContactCellContent, label: "Contact", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Third-Party Clients", tabLabel: "Third-Party Clients", icon: "fa-solid fa-child",
      data: [
        { name: ClientItem.getTpClientsContent, label: "Third-Party Clients", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Opportunities", tabLabel: "Opportunities", icon: "fa-regular fa-face-smile fa-2x",
      data: [
        { name: ClientItem.getOpportunityCellContent, label: "Opportunities", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Projects", tabLabel: "Projects", icon: "fa-solid fa-link-simple",
      data: [
        { name: ClientItem.getProjectCellContent, label: "Projects", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Surveys", tabLabel: "Surveys", icon: "fa-brands fa-grav fa-2x",
      data: [
        { name: ClientItem.getSurveyContent, label: "Surveys", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Assignments", tabLabel: "Assignments", icon: "fa-solid fa-clipboard-list",
      data: [
        { name: ClientItem.getAssignmentsContent, label: "Assignments", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: 'Third-Party Jobs', tabLabel: 'Third-Party Jobs', icon: 'fa-solid fa-clipboard-list',
      data: [
        { name: ClientItem.getTpJobsContent, label: 'Third-Party Jobs', width: TabListTableCellWidthEnum.Table },
      ],
    },
    {
      // Offered only when the client (or a child client) has a won opportunity and a completed, billable shop -
      // the server decides, so the tab appears a moment after the detail opens (CD-5650).
      tabName: 'Pricing History', tabLabel: 'Pricing History', icon: 'fa-solid fa-chart-line',
      rolekey: 'client_pricinghistory',
      visibleWhen: (item) => ClientPricingHistoryService.GetAvailability(item.ClientId),
      data: [
        { name: ClientItem.getPricingHistoryContent, label: 'Pricing History', width: TabListTableCellWidthEnum.Table },
      ],
    },
    {
      tabName: "Sub Clients", tabLabel: "Sub Clients", icon: "fa-solid fa-child",
      data: [
        { name: ClientItem.getSubClientsContent, label: "Sub Clients", width: TabListTableCellWidthEnum.Table, },
      ],
    },

    {
      tabName: "Attachments", tabLabel: "Attachments", icon: "fa-solid fa-paperclip",
      data: [
        { name: ClientItem.getAttachmentsCellContent, label: "Attachments", width: TabListTableCellWidthEnum.Table, },
      ],
    },
    {
      tabName: "Comments", tabLabel: "Comments", icon: "fa-solid fa-comment",
      data: [
        { name: ClientItem.getCommentsCellContent, label: "Comments", width: TabListTableCellWidthEnum.Table, },
        { name: "-message-", label: "The comments above are related to the primary user.", },
      ],
    },
    {
      tabName: "Log", tabLabel: "Log", icon: "fa-solid fa-stream",
      data: [
        { name: ClientItem.getLogCellContent, label: "Log", width: TabListTableCellWidthEnum.Table, },
      ],
    },
  ];

  static GetParentCellContent(item) {
    if (!item.ParentId) {
      return '';
    }

    return urlHelper.getIconLinkComponentFigma(
      `${item.ParentName} (${item.ParentId})`,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_clients/search',
      `Name=${item.ParentId}&OfficeId=`,
      'Open parent on a new tab'
    );
  }

  static getIsActiveCellContent(item) {
    return <div className='pointer'>{<FigmaBadge Active={item.IsActive} />}</div>;
  }

  static getIdFieldData(item) {
    if (item.IsSubClientsView === false) return item.ClientId;

    return ClientItem.getIdFieldNavigationLink(item);
  }

  static getIdFieldNavigationLink(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ClientId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'sales_clients/search',
      `Name=${item.ClientId}&OfficeId=`,
      'Open up in a new tab'
    );
  }

  static getIdFieldType(item) {
    if (item.IsSubClientsView === false) {
      return FieldTypesEnum.DataFieldWithDetails;
    }
    return FieldTypesEnum.Navigation;
  }

  static getAssignmentsContent(item) {
    const tabs = [
      {
        label: 'Ready for Invoicing',
        id: 'finalized',
        icon: 'fa-solid fa-monument',
        component: (
          <FinalizedAssignmentsList
            Item={item}
            type='finalized_client'
          />
        ),
      },
      {
        label: 'Uninvoiceable',
        id: 'uninvoicable',
        icon: 'fa-solid fa-monument',
        component: (
          <UninvoiceableAssignmentsList
            CfId={item.ClientId}
            type='uninvoiceable_client'
          />
        ),
      },
      {
        label: 'Excluded Pay Evaluators',
        id: 'excluded',
        icon: 'fa-solid fa-monument',
        component: (
          <ExcludedAssignmentsList
            CfId={item.ClientId}
            type='excluded_client'
          />
        ),
      },
      {
        label: 'All Assignments',
        id: 'all',
        icon: 'fa-solid fa-monument',
        component: (
          <AllAssignmentsList
            CfId={item.ClientId}
            type='all_client'
          />
        ),
      },
    ];
    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static getPricingHistoryContent(item) {
    return <ClientPricingHistoryTab clientId={item.ClientId} />;
  }

  static getTpJobsContent(item) {
    const tabs = [
      {
        label: 'Ready for Invoicing',
        id: 'finalized',
        icon: 'fa-solid fa-monument',
        component: (
          <FinalizedTpJobsAdmin
            ClientId={item.ClientId}
            SearchType='finalized'
          />
        ),
      },
      {
        label: 'Uninvoiceable',
        id: 'uninvoicable',
        icon: 'fa-solid fa-monument',
        component: (
          <UninvoiceableTpJobAdmin
            ClientId={item.ClientId}
            SearchType='uninvoiceable'
          />
        ),
      },
      {
        label: 'Excluded Pay Evaluators',
        id: 'excluded',
        icon: 'fa-solid fa-monument',
        component: (
          <ExcludedTpJobsAdmin
            ClientId={item.ClientId}
            SearchType='excluded'
          />
        ),
      },
      {
        label: 'All Third-Party Jobs',
        id: 'all',
        icon: 'fa-solid fa-monument',
        component: (
          <AllTpJobsAdmin
            ClientId={item.ClientId}
            SearchType='all'
          />
        ),
      },
    ];
    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static getActionsCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => ClientItem.editFunction(item.ClientId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'ClientContact_faicon_CreateEdit',
          },
          {
            text: item.SassieId !== null ? `Sassie Id: (${item.SassieId})` : 'Insert Appolo Sassie ID',
            onClick: () => ClientItem.sassieeditFunction(item.ClientId, item),
            iconName: 'fa-brands fa-grav',
            roleKey: 'ClientContact_faicon_CreateEdit',
            disabled: item.SassieId !== null,
          },
          {
            text: 'Location',
            link: <LocationsAdmin Name={item.Name} />,
            iconName: 'fa-solid fa-location-dot',
            roleKey: 'location_link',
            url: 'locations',
            title: 'Locations',
          },
          {
            text: 'Add External Questionaire',
            onClick: () => ClientItem.addExternalQuestionaireFunction(item.ClientId, item),
            iconName: 'fa-solid fa-person-circle-plus',
            roleKey: 'justForAdmins',
          },
          // {
          //   onClick: () => ClientItem.assignmentsFunction(item.EvaluatorId, item),
          //   text: "Assignments",
          //   iconName: "fa-solid fa-tasks",
          // },
          {
            iconName: 'fa-solid fa-file-invoice',
            roleKey: `clientInvoice_link`,
            text: 'Invoices',
            url: `/operations_invoices/search?ClientNameOrId=${item.ClientId}`,
            title: 'Client Invoices',
            disabled: false,
          },
          {
            iconName: 'fa-solid fa-file-invoice',
            roleKey: `tpclientinvoices_view`,
            text: 'Third-Party Invoices',
            url: `/operations_tpinvoices/search?ClientNameOrId=${item.ClientId}`,
            title: 'Third-Party Client Invoices',
            disabled: false,
          },
          {
            text: 'Create Invoice',
            onClick: () => ClientItem.createInvoiceFunction(item.ClientId, item),
            iconName: 'fa-solid fa-file-invoice-dollar',
            roleKey: 'clientInvoice_Create',
          },
          {
            text: 'Create Third-Party Invoice',
            onClick: () => ClientItem.createInvoiceNewFunction(item.ClientId, item),
            iconName: 'fa-solid fa-file-invoice-dollar',
            roleKey: 'tpclientinvoices_create',
          },
          {
            iconName: 'fa-solid fa-credit-card',
            roleKey: `creditmemorequest_link`,
            text: 'Credit Memo Requests',
            url: `/creditmemo/search?ClientId=${item.ClientId}&tab=${1}`,
            title: 'Credit Memo Requests',
            disabled: false,
          },
          {
            iconName: 'fa-solid fa-credit-card',
            roleKey: `creditmemo_link`,
            text: 'Credit Memos',
            url: `/creditmemo/search?ClientId=${item.ClientId}&tab=${0}`,
            title: 'Credit Memos',
            disabled: false,
          },
          {
            text: 'Third-Party Credit Memos',
            iconName: 'fa-solid fa-credit-card',
            roleKey: `tpcreditmemos_view`,
            url: `/tpcreditmemo/search?ClientNameOrId=${item.ClientId}`,
            title: 'Third-Party Credit Memos',
            disabled: false,
          },
          {
            iconName: 'fa-solid fa-money-bill-wave',
            roleKey: `clientPayment_link`,
            text: 'Client Payments',
            url: `/finance_clientpayment/search?ClientNameOrId=${item.ClientId}`,
            title: 'Client Payments',
            disabled: false,
          },
          {
            iconName: 'fa-solid fa-money-bill-wave',
            roleKey: `clientPayment_link`,
            text: 'Client Payments (New)',
            url: `/new_finance_clientpayment/search?OfficeIds=&ClientNameOrId=${item.ClientId}&PaymentListType=all`,
            title: 'Client Payments (New)',
            disabled: false,
          },
          {
            text: 'Create Client Payment',
            onClick: () => ClientItem.createPaymentFunction(item.ClientId, item),
            iconName: 'fa-solid fa-file-circle-plus',
            roleKey: 'clientpayment_create',
          },
          {
            text: 'Create Client Payment (New)',
            onClick: () => ClientItem.createTpPaymentFunction(item.ClientId, item),
            iconName: 'fa-solid fa-file-circle-plus',
            roleKey: 'tp_clientpayment_create',
          },
          {
            text: 'Link to Parent',
            onClick: () => ClientItem.addParentFunction(item.ClientId, item),
            iconName: 'fa-solid fa-person-circle-plus',
            roleKey: 'ClientContact_faicon_CreateEdit',
            hide: item.ParentId !== null,
          },
          {
            text: 'Unlink from Parent',
            onClick: () => ClientItem.removeParentFunction(item.ClientId, item),
            iconName: 'fa-solid fa-person-circle-minus',
            roleKey: 'ClientContact_faicon_CreateEdit',
            hide: item.ParentId == null,
          },
        ]}
      />
    );
  }

  static getCommentsCellContent(item) {
    return (
      <Comments
        entityTypeId={7}
        entityId={item.ClientId}
      />
    );
  }

  static getAttachmentsCellContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={7}
        entityId={item.ClientId}
        enableAddNew={false}
      />
    );
  }

  static getLogCellContent(item) {
    return (
      <LogComponent
        entityType='Client'
        entityId={item.ClientId}
      />
    );
  }

  static getSurveyContent(item) {
    const tabs = [
      {
        label: 'Surveys',
        id: 'surveys',
        icon: 'fa-brands fa-grav fa-2x',
        component: (
          <SurveyAdmin
            clientId={item.ClientId}
            IsActive={item.IsActive}
            SassieId={item.SassieId}
          />
        ),
      },
      {
        label: 'Third-Party Surveys',
        id: 'tpsurveys',
        icon: 'fa-regular fa-champagne-glasses',
        component: (
          <TpSurveyAdmin
            ClientId={item.ClientId}
            IsSubClientsView={true}
          />
        ),
      },
    ];

    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static getContactCellContent(item) {
    return (
      <ContactComponent
        ClientId={item.ClientId}
        ClientItem={item}
      />
    );
  }

  static getOpportunityCellContent(item) {
    return (
      <OpportunityAdmin
        Navigation={true}
        ClientId={item.ClientId}
        LeadId={item.LeadId}
        OfficeId={item.OfficeId}
      />
    );
  }

  static getProjectCellContent(item) {
    const tabs = [
      {
        label: 'Projects',
        id: 'projects',
        icon: 'fa-solid fa-link-simple',
        component: <ProjectComponent ClientId={item.ClientId} />,
      },
      {
        label: 'Third-Party Projects',
        id: 'new-projects',
        icon: 'fa-regular fa-champagne-glasses',
        component: <NewProjectAdmin ClientId={item.ClientId} />,
      },
    ];

    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static getSubClientsContent(item) {
    return (
      <ClientAdmin
        ParentId={item.ClientId}
        IsSubClientsView={true}
      />
    );
  }

  static getTpClientsContent(item) {
    return <TpClientLinkAdmin ClientId={item.ClientId} />;
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static assignmentsFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static sassieeditFunction = (item) => {
    alert('Empty function');
  };

  static createInvoiceFunction = (clientId, item) => {
    alert('Empty function');
  };

  static createInvoiceNewFunction = (clientId, item) => {
    alert('Empty function');
  };

  static createPaymentFunction = (clientId, item) => {
    alert('Empty function');
  };

  static createTpPaymentFunction = (clientId, item) => {
    alert('Empty function');
  };

  static addParentFunction = (clientId, item) => {
    alert('Empty function');
  };

  static removeParentFunction = (clientId, item) => {
    alert('Empty function');
  };

  static addExternalQuestionaireFunction = (clientId, item) => {
    alert('Empty function');
  };
}
